<style lang="less">
  .table-template{
    .table-template-header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .table-template-search{
        display: flex;
        align-items: center;
      }
    }
    .table-template-body{
      margin-top: 15px;
      .paginatioin{
        float: right;
        margin-top: 10px;
      }
    }
  }
</style>
<template>
  <div class="table-template">
    <div class="table-template-header">
      <div class="table-template-search">
        <el-input
          size="small"
          v-model="searchContent"
          :placeholder="queryObj.displayLabel"
          style=" margin-right: 3px;"
          @keyup.enter.native="searchData"></el-input>
        <el-button type="primary" icon="search" size="small" @click="searchData">搜索</el-button>
      </div>
      <div>
        <slot name="add"></slot>
      </div>
    </div>
    <div class="table-template-body">
      <el-table :data="tableData"
                border
                v-loading="loading"
                style="width: 100%; margin-top: 15px;">
        <template v-for="(item, index) in dictionaryArr">
          <el-table-column
            :key="index"
            :prop="item"
            :label="dictionary[item]"
            min-width="150">
            <template slot-scope='scopestatus'>
              <el-tag type="success" v-if="item === 'Tag' || item === 'Tag1' && scopestatus.row[item] === 0 ">启用</el-tag>
              <el-tag type="warning" v-else-if="item === 'Tag' || item === 'Tag1' && scopestatus.row[item] === 2">维护</el-tag>
              <el-tag type="gray" v-else-if="item === 'Tag' || item === 'Tag1' && scopestatus.row[item] === 1">禁用</el-tag>
              <span v-else-if="item === 'Status' && scopestatus.row[item] === 1">禁用</span>
              <span v-else-if="item === 'Status' && scopestatus.row[item] === 0">正常</span>
              <span v-else>{{scopestatus.row[item]}}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" min-width="380" >
          <template slot-scope="scope" v-if="dictionaryArr.length > 0">
            <el-button type="primary" size="small" icon="edit" v-if="showopertbtn.edit" @click="editItem(scope.$index, scope.row)">查看</el-button>
            <el-button type="danger" size="small" icon="delete" v-if="showopertbtn.del" @click="deleteItem(scope.$index, scope.row)">删除</el-button>
            <el-button type="primary" size="small" icon="view" v-if="showopertbtn.defined" @click="enterDefined(scope.$index, scope.row)">进入接口定义</el-button>
            <el-button type="primary" size="small"   v-if="showopertbtn.export" @click="exportSql(scope.$index, scope.row)">导出</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change = 'queryNewSize'
        @current-change = 'queryNewPage'
        class="paginatioin"
        :page-sizes="[10, 20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import util from '../../util.js'
  import {TableData} from '../../vuex/actions'
  import {GetTableData} from '../../vuex/getters'
	export default {
	  props: ['queryobj', 'queryparam', 'showopertbtn'],
    vuex: {
      getters: {
        GetTableData
      },
      actions: {
        TableData
      }
    },
	  data() {
	    return {
	      totalCount:0,
        queryObj: this.queryobj,
        loading: false,
        searchContent: '',
        currentPage: 1,
        pageSize: 10,
        tableData:[{}],
        dictionary: [],
        dictionaryArr: [],
      }
    },
    watch: {
      'queryobj': {
        handler: function () {
          if(this.queryobj.AppID){
            this.queryObj.AppID = this.queryobj.AppID
          }
        },
        deep: true
      }
    },
    mounted () {
	    this.searchData()
    },
    methods: {
      editItem (index, row) {
        this.$emit('editItem', row)
      },
      deleteItem (index, row) {
        console.log(row)
        this.$emit('delItem', row)
      },
      enterDefined (index, row) {
        this.$emit('enterdefined', row)
      },
      exportSql(index,row){
        console.log(row)
        let params = {
           "groupNO":row.GroupNO,
          "groupName":encodeURIComponent(encodeURIComponent(row.GroupName))
        }
        window.location.href=util.getUrl()+'/sql/oAuthSqlExport?' + util.jsonToQueryParam(params);
      },
      searchData () {
        this.loading = true
        this.queryObj[this.queryparam] = this.searchContent.trim()
        let params = {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          ...this.queryObj,
        }
        delete params.displayLabel
        this.TableData(params, (res) => {
          this.loading = false
          if (res.isValid && res.data.isValid){
            this.tableData = res.data.dataList
            this.dictionary = res.data.dictionary
            this.dictionaryArr = filterArr(res.data.dictionary, res.data.hideFields)
            this.totalCount = res.totalCount
          }
        })
      },
      queryNewSize (size) {
        this.pageSize = size
        this.searchData()
      },
      queryNewPage (Page) {
        this.currentPage = Page
        this.searchData()
      },
      //ref调用函数
      addTableCol () {

      },
      delTableCol () {},
    },
  }
  //工具
  function filterArr(dicArr, hideArr){
    //console.log(dicArr);console.log(hideArr);
    let hide = hideArr.split(';')
    let arr = []
    for(var i in dicArr){
      if(!hide.includes(i)){
        arr.push(i)
      }
    }
    return arr
  }
</script>




// WEBPACK FOOTER //
// showtable.vue?b2f1946e